<template>
  <div
  class="dropdown no-select"
  ref="dropdown"
  :class="{
    active: opened,
    right: right
  }"
  @mousedown.stop
  >
    <div
    class="dropdown_display"
    @click.stop="open($event)"
    >
      <slot name="display"></slot>
    </div>
    <div v-show="opened" class="menu dropdown_menu"
    @click.stop>
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { EventBus } from './event-bus.js'

export default {
  props: {
    right: {
      default: false
    },
    opened: {
      default: false
    }
  },

  watch: {
    opened: function (val) {
      if (val) {
        this.prepClose()
        EventBus.$emit('dropdown-closeAll', this._uid)
      }
      else {
        this.unprepClose()
      }
    }
  },

  data () {
    return {
    }
  },

  methods: {
    open (e) {
      console.log('open', e)
      this.$emit('update:opened', true)
      this.$emit('open')
    },
    close () {
      this.$emit('update:opened', false)
      // console.log('close')
      this.$emit('close')
    },
    _close () {
      this.$emit('update:opened', false)
    },
    prepClose () {
      window.addEventListener('click', this.bindedCloseAll)
      // window.addEventListener('click', this.bindedClose)
    },
    unprepClose () {
      window.removeEventListener('click', this.bindedCloseAll)
      // window.removeEventListener('click', this.bindedClose)
    },
    closeAll () {
      EventBus.$emit('dropdown-closeAll', null)
    },
    closeAllBut () {
      EventBus.$emit('dropdown-closeAll', this._uid)
    }
  },

  mounted () {
    let vm = this

    this.bindedClose = this.close.bind(this)
    this.bindedCloseAll = this.closeAll.bind(this)
    this.bindedCloseAllBut = this.closeAllBut.bind(this)
    // this.loadDropdown()
    // console.log(this.loading)
    EventBus.$on('dropdown-closeAll', _uid => {
      if (vm._uid !== _uid) {
        this.close()
      }
      // console.log(`Oh, that's nice. It's gotten ${_uid} clicks! :)`)
    })
  }

}
</script>
<style>
.active > .dropdown_menu {
  display: block !important;
  z-index: 7000;
}

.noscroll .dropdown_menu {
  overflow: visible !important;
  max-height: none !important;
}
/*
.vlist .dropdown_menu {
  overflow: hidden !important;
}*/

.dropdown {
  cursor: pointer;
  position: relative;
  display: inline-block;
  outline: none;
  text-align: left;
  -webkit-transition: box-shadow 0.1s ease, width 0.1s ease;
  transition: box-shadow 0.1s ease, width 0.1s ease;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.dropdown.no-overflow .dropdown_menu {
  min-width: 0;
}

.dropdown_menu {
  cursor: auto;
  position: absolute;
  display: none;
  outline: none;
  top: 100%;
  width: 100%;
  min-width: -webkit-max-content;
  min-width: -moz-max-content;
  min-width: max-content;
  margin: 0em;
  padding: 0em 0em;
  background: #FFFFFF;
  font-size: 1em;
  text-shadow: none;
  text-align: left;
  box-shadow: 0px 2px 3px 0px rgba(34, 36, 38, 0.15);
  border: 1px solid rgba(34, 36, 38, 0.15);
  z-index: 120;
  /*will-change: transform, opacity;*/
}

.dropdown_display {
  z-index: 109;
  position: relative;
}

.dropdown.right .dropdown_menu {
  right: 0;
}

.dropdown_menu_content {
  width: 100%;
  height: 100%;
  position: relative;
  background: rgba(255,0,0,0.23);
}

.dropdown_menu > * {
  white-space: nowrap;
}

.dropdown_menu > .item {
  position: relative;
  cursor: pointer;
  display: block;
  border: none;
  height: auto;
  text-align: left;
  border-top: none;
  line-height: 1.5em;
  padding: 0.78571429rem 1.14285714rem !important;
  font-size: 1rem;
  text-transform: none;
  font-weight: normal;
  box-shadow: none;
  -webkit-touch-callout: none;
}

.dropdown_menu > .item.selected {
  background-color: #1976d2;
  background-color: #4b96e0;
}

.dropdown_menu > .item.selected > i,
.dropdown_menu > .item.selected > span{
  color: #fff;
  text-shadow: 0 0 1px #000;
  font-weight: bold;
}

.dropdown_menu > .item:first-child {
  border-top-width: 0px;
}

.fluid.dropdown {
  display: block;
  width: 100%;
  min-width: 0em;
}

.dropdown_menu .item i {
  padding: 0 6px;
  line-height: 100%;
}
</style>
